import { priceConstants } from '../constants';

export function prices(state = {}, action) {
  switch (action.type) {
    case priceConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case priceConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case priceConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddPrice(state = {}, action) {
  switch (action.type) {
    case priceConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      }
    case priceConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        item: action.item,
        loading: false
      }
    case priceConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function GetPrice(state = {}, action) {
  switch (action.type) {
    case priceConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case priceConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case priceConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdatePrice(state = {}, action) {
  switch (action.type) {
    case priceConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case priceConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        item: action.item,
        loading: false
      }
    case priceConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}